export default "__VITE_ASSET__DI2JCQko__"